import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../navbar';
import { productsService } from '../../services/api/products.service';
import { config, buildImageUrl } from '../../config';

function ProductList() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const data = await productsService.getAllProducts();
      setProducts(Array.isArray(data) ? data : []);
    } catch (err) {
      setError((err && (err.message || err.error)) || String(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return (
    <>
      <div className="flex">
        <Navbar />
      </div>
      <div className="max-w-6xl mx-auto p-4 mt-20">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold">Products</h1>
          <Link to="/products/add" className="bg-blue-600 text-white px-4 py-2 rounded">
            Add Product
          </Link>
        </div>

        {loading && <div className="text-center">Loading...</div>}
        {error && <div className="text-red-600">{error}</div>}

        {!loading && !error && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {products.map((product) => (
              <div key={product._id} className="border rounded-lg overflow-hidden bg-white shadow-sm">
                <div className="relative h-48">
                  <img
                    src={product.images && product.images[0] ? buildImageUrl(product.images[0]) : config.defaultImage}
                    alt={product.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = config.defaultImage;
                    }}
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-lg mb-2">{product.name}</h3>
                  <p className="text-gray-600 text-sm mb-2 line-clamp-2">{product.description}</p>
                  <p className="text-blue-600 font-semibold mb-4">₹{product.price}</p>
                  
                  <div className="flex justify-end space-x-2">
                    <Link
                      to={`/products/edit/${product._id}`}
                      className="text-blue-600 hover:text-blue-700 font-medium text-sm"
                    >
                      Edit
                    </Link>
                    <Link
                      to={`/products/delete/${product._id}`}
                      className="text-red-600 hover:text-red-700 font-medium text-sm"
                    >
                      Delete
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {!loading && !error && products.length === 0 && (
          <div className="text-center text-gray-600 mt-8">No products found</div>
        )}
      </div>
    </>
  );
}

export default ProductList;